const parseQueryUrl = (apiUrl, paramData) => {
  return apiUrl.replace(paramData.key, paramData.value);
};

const helpers = {
  parseQueryUrl,
};

export default helpers;
